import { NavLink } from "react-router-dom";

export function NavigationLink(props) {
    return (
        <NavLink
            className={({ isActive }) =>
                [
                    "flex justify-center text-center text-base items-center h-full cursor-pointer font-bold no-underline",
                    props.className,
                    isActive ? "!text-[#2f805a]" : "text-pine",
                ].join(" ")
            }
            to={props.target}
            onClick={() => {
                // Used to let users click "Home" to scroll to top when already on the Home-page
                const anchor = document.querySelector("#top");
                if (anchor) {
                    anchor.scrollIntoView({
                        behavior: "smooth",
                        block: "center",
                    });
                }
            }}
        >
            {props.content}
        </NavLink>
    );
}
